import type { Experience } from './experience'

const STORAGE_PREFIX = 'sigchatExpmgrExperience:'

function storageKey(contactToken: string): string {
  return `${STORAGE_PREFIX}${contactToken.trim()}`
}

function isExperience(v: string | null): v is Experience {
  return v === 'legacy' || v === 'new'
}

export function readPersistedExperienceForToken(contactToken: string): Experience | undefined {
  const trimmed = contactToken.trim()
  if (trimmed.length === 0) return undefined
  try {
    const raw = sessionStorage.getItem(storageKey(trimmed))
    if (raw !== null && isExperience(raw)) return raw
  } catch {
    return undefined
  }
  return undefined
}

export function writePersistedExperienceForToken(
  contactToken: string,
  experience: Experience,
): void {
  const trimmed = contactToken.trim()
  if (trimmed.length === 0) return
  try {
    sessionStorage.setItem(storageKey(trimmed), experience)
  } catch {
    return
  }
}
